import React from 'react';

import IconCarouselVariant from './icon-carousel-variant';
import SimpleBarVariant from './simple-bar-variant';
import type { LoadingOverlayProps } from './types';

/**
 * Loading overlay for native embeds. Renders one of two variants:
 * - `'icon-carousel'` (default): rotating icons + centred progress bar.
 * - `'simple-bar'`: bottom-aligned progress bar with optional blanket.
 *
 * See `LoadingOverlayProps` for variant-specific options.
 */
export default function LoadingOverlay(props: LoadingOverlayProps): React.JSX.Element {
	if (props.variant === 'simple-bar') {
		const { variant: _variant, ...rest } = props;
		return <SimpleBarVariant {...rest} />;
	}

	const { variant: _variant, ...rest } = props;
	return <IconCarouselVariant {...rest} />;
}
